import React from "react";
import { useHistory } from "react-router";
import { Tab } from "@material-ui/core";

import { theme } from "../theme";

export type LinkTabProps = {
  label: string;
  to: string;
};

function LinkTab({ label, to }: LinkTabProps) {
  const history = useHistory();
  const isSelected = history.location.pathname === to;

  return (
    <Tab
      component="a"
      disableRipple={true}
      disableFocusRipple={true}
      onClick={(event) => {
        event.preventDefault();
        history.push(to);
      }}
      label={label}
      selected={isSelected}
      style={{
        background: isSelected ? "white" : "inherit",
        color: isSelected
          ? theme.palette.text.primary
          : theme.palette.text.secondary,
        cursor: "pointer",
      }}
    />
  );
}

export default LinkTab;
